export default
{
    L_BR: 'l_br',
    R_TL: 'r_tl',
    L_BC: 'l_bc'
}



// WEBPACK FOOTER //
// ./src/scripts/constants/home-layouts.js